import React from 'react';
import fp from 'lodash/fp';
import {
  SelectProps as MuiSelectProps,
  FormControlProps as MuiFormControlProps,
  InputBaseProps as MuiInputBaseProps,
  InputLabel,
  MenuItem,
  Box
} from '@mui/material';

import { StyledSelect, StyledFormControl, StyledPlaceholder } from './styled';
import { ISelectProps } from '../types';
import { IconArrowDropDown, IconErrorCircle } from '@mzc-cloudplex/icons';

type extendedSelectProps = MuiSelectProps & MuiFormControlProps & MuiInputBaseProps & ISelectProps;
import { Checkbox } from '../checkbox';

export const Select = ({
  children,
  variant,
  color,
  label,
  value,
  size,
  options,
  onChange,
  error,
  menuSize,
  multiple,
  fullWidth,
  disabled,
  readOnly,
  required,
  errorMessage,
  placeholder,
  ...props
}: extendedSelectProps) => {
  return (
    <StyledFormControl error={error} disabled={disabled} required={required} fullWidth={fullWidth}>
      {label && <InputLabel>{label}</InputLabel>}
      <StyledSelect
        className={readOnly ? 'Mui-readOnly' : undefined}
        label={label}
        options={options}
        variant={variant}
        color={color}
        value={value}
        size={size}
        onChange={onChange}
        fullWidth={fullWidth}
        placeholder={placeholder}
        displayEmpty={!!placeholder}
        multiple={multiple}
        {...props}
        inputProps={{ 'aria-label': 'Without label', readOnly: !!readOnly }}
        MenuProps={{
          ...props.MenuProps,
          PaperProps: {
            ...props.MenuProps?.PaperProps,
            style: {
              ...props.MenuProps?.PaperProps?.style,
              marginTop: '2px'
            }
          }
        }}
        IconComponent={() => (
          <Box
            sx={{
              display: `inline-flex`,
              alignItems: `center`,
              justifyContent: `center`,
              position: `absolute`,
              right: 0,
              top: label ? 0 : `-5px`,
              bottom: 0,
              zIndex: 0
            }}
          >
            {error && <IconErrorCircle size={16} color={'error'} />}
            <Box
              sx={{
                display: `inline-flex`,
                alignItems: `center`,
                justifyContent: `center`,
                width: `24px`,
                height: `24px`,
                margin: `0 8px`,
                opacity: disabled ? '0.48' : 1
              }}
            >
              <IconArrowDropDown size={8} htmlColor={'#3c3d4f'} />
            </Box>
          </Box>
        )}
      >
        {placeholder && (
          <StyledPlaceholder disabled value='' sx={{ display: `none` }}>
            <span style={{ color: '#9898ad' }}>{placeholder}</span>
          </StyledPlaceholder>
        )}
        {fp.map(
          (elem) => (
            <MenuItem
              key={elem.value}
              value={elem.value}
              sx={{
                minHeight: menuSize === 'small' ? `32px` : `40px`,
                '&.Mui-selected': { backgroundColor: '#c9d4f480' },
                '&:hover': { backgroundColor: '#3c3d4f0A' },
                '.MuiSvgIcon-root': { marginRight: `8px` }
              }}
            >
              {elem.check && <Checkbox color={'default'} />}
              {elem.label}
            </MenuItem>
          ),
          options
        )}
      </StyledSelect>
      {errorMessage && <>{errorMessage}</>}
    </StyledFormControl>
  );
};
